import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import {
  LandingPageActions,
  resetCostTables,
} from '../actions/landing-page.actions';

@Injectable()
export class LandingPageEffects {
  resetCostTables$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        LandingPageActions.ClearInputData,
        LandingPageActions.SubmitDefaults
      ),
      map(() => {
        return resetCostTables();
      })
    )
  );

  constructor(private actions$: Actions) {}
}
